module.exports = __webpack_public_path__ + "static/media/london_25-sits_oppet_avslut_tyg_mito_miljo_2023_1.a5e87f67.jpg";